/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from "react";
import { TiTick } from "react-icons/ti";
import { LiaHourglassEndSolid } from "react-icons/lia";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { addMessagePagination, cacheMessages } from "../../Redux/reducers/messagesSlice";
import { setSent, setTyping } from "../../Redux/reducers/sendingSlice";
import { useCallbackRef } from "../../Utils/useCallbackRef";
import { SocketContext } from "../Context/ContextProvider";
import { fetchChatCustomers } from "./fetchingData/fetchCustomers";
import { fetchChatSellers } from "./fetchingData/fetchSellers";
import ChatLoading from "./loaders/ChatLoading";
import EndOfConversation from "./loaders/EndOfConversation";
import LoadingSpinner from "./loaders/LoadingSpinner";
import MessageContainer from "./singleItems/SingleMessageContainer";

export default function ChatConversationPane({ conversationData, isLoading }) {
  const dispatch = useDispatch();
  const messages = useSelector((state) => state.messages.messages);
  const sending = useSelector((state) => state.sendingStatus.sending.isSending);
  const sent = useSelector((state) => state.sendingStatus.sending.sent);

  const isTyping = useSelector((state) => state.sendingStatus.sending.isTyping);
  const currRole = useSelector((state) => state.chatRole.role);
  const user = useSelector((state) => state.user.user);
  const [hasMore, setHasMore] = useState(true);

  const scrollRef = useRef(null)

  const socket = useContext(SocketContext)

  const { id: currConversationId, convContext } = useSelector((state) => state.conversationId);
  const currConvIdRef = useCallbackRef(currConversationId)
  const currConvContextRef = useCallbackRef(convContext)

  const cachedMessages = useSelector((state) => state.messages.cachedMessages);
  const cachedMessagesRef = useCallbackRef(cachedMessages)

  // get typing status from the socket ............................
  useEffect(() => {
    if (socket) {
      let typingTimeout;

      socket.on("typing", (data) => {
        // Handle the received data here
        if ((currConvContextRef.current === 'customers' && (+currConvIdRef.current) === (+data.customer_id)) ||
          (currConvContextRef.current === 'sellers' && (+currConvIdRef.current) === (+data.seller_id))) {

          dispatch(setTyping(true));
          clearTimeout(typingTimeout);
          typingTimeout = setTimeout(() => {
            dispatch(setTyping(false)); // Hide typing status after 1 second of inactivity
          }, 1000);
        }
      });


      return () => {
        clearTimeout(typingTimeout);
        dispatch(setTyping(false));
        socket.off("typing");
      };
    }
  }, [socket, currConversationId, conversationData, currRole, dispatch]);

  // function to fetch more chat while scrolling down the page
  const fetchMoreChat = async () => {
    if (user !== null) {
      if (currRole === "customer") {
        if (currConversationId !== 0) {
          const controller = new AbortController();
          const signal = controller.signal;
          const currPage = cachedMessagesRef.current.sellers[currConversationId].current_page
          const sellersChat = await fetchChatSellers({
            id: currConversationId,
            page: currPage + 1,
            signal,
          });

          dispatch(addMessagePagination(sellersChat.data));
          dispatch(cacheMessages({ conversationId: currConversationId, chat: sellersChat.data, isSeller: true, append: true, current_page: sellersChat.current_page }))
          setHasMore(sellersChat?.current_page < sellersChat?.last_page);
        }
      }
      if (currRole === "seller") {
        if (currConversationId !== 0) {
          const controller = new AbortController();
          const signal = controller.signal;
          const currPage = cachedMessagesRef.current.customers[currConversationId].current_page
          const customersChat = await fetchChatCustomers({
            id: currConversationId,
            page: currPage + 1,
            signal,
          });
          dispatch(addMessagePagination(customersChat.data));
          dispatch(cacheMessages({ conversationId: currConversationId, chat: customersChat.data, isSeller: false, append: true, current_page: customersChat.current_page }))

          setHasMore(customersChat.current_page < customersChat.last_page);
        }
      }
    }
  };

  useEffect(() => {
    setTimeout(() => {
      dispatch(setSent(false));
    }, [2000]);
  }, [dispatch, sent]);


  // setting current page to 1 when conversation changes
  useEffect(() => {
    setHasMore(true);
    if (scrollRef.current) {
      scrollRef.current.scrollTo(0, 0)
    }
  }, [currConversationId]);

  return (
    <div
      ref={scrollRef}
      className="conversation-pane no-scrollbar flex-1 flex-grow-1"
      id="conversation_pane"
      onScroll={(e) => e.stopPropagation()}
    // style={{
    //   // backgroundImage: `url("${window.location.origin}/images/chat-bg.png")`
    //   backgroundImage: `url("https://img.freepik.com/free-vector/mandala-patterns-isolated-background_1308-69554.jpg")`
    // }}
    >

      {isLoading ? (
        <ChatLoading />
      ) : (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <span
              style={{
                fontSize: "10px",
                color: "",
                textAlign: "right",
              }}
            >
              {sending && <>sending <LiaHourglassEndSolid size={15} /></>}
              {sent && (
                <>
                  sent <TiTick size={15} color="#d1027e" />
                </>
              )}
            </span>
            {isTyping && (
              <div className="isTyping">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "4px",
                  }}
                >
                  <div className="balls"></div>
                  <div className="balls"></div>
                  <div className="balls"></div>
                  <p
                    style={{
                      fontSize: "10px",
                      color: "#9e9e9e",
                      textAlign: "right",
                      marginTop: "5px",
                    }}
                  >
                    user is typing...
                  </p>
                </div>
              </div>
            )}
          </div>

          <InfiniteScroll
            scrollableTarget="conversation_pane"
            next={fetchMoreChat}
            endMessage={<EndOfConversation />}
            loader={<LoadingSpinner />}
            hasMore={hasMore}
            dataLength={messages.length}
            style={{
              display: "flex",
              flexDirection: "column-reverse",
            }}
            inverse={true}
          >
            {messages.map((msg, i) => {
              return (
                <MessageContainer
                  message={msg.message}
                  position={msg.position}
                  time={msg.created_at}
                  key={i}
                />
              );
            })}
          </InfiniteScroll>
        </>
      )}
    </div>
  );
}
